export class ExportSurveyDto {
  blockAreaId: string;
  fiberHoodAreaId: string;
  filterOnSelectedColumns: boolean;

  constructor(
    fiberHoodAreaId: string,
    blockAreaId: string,
    filterOnSelectedColumns?: boolean
  ) {
    this.blockAreaId = blockAreaId;
    this.fiberHoodAreaId = fiberHoodAreaId;
    this.filterOnSelectedColumns = filterOnSelectedColumns;
  }
}
